import {injectable} from "tsyringe";
import {CreateKeywordCommand} from "../commands/create-keyword.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {Keyword} from "../domain/entities/keyword.entity";
import {TransformerHelper} from "../helpers/transformer.helper";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

@injectable()
@transformer({
    source: CreateKeywordCommand,
    target: `dto`
})
export class CreateKeywordCommandToDtoTransformer extends AbstractCommandToDtoTransformer<Keyword> {

    protected async toDTO(keyword: Keyword): Promise<DataTransferObject> {
        return TransformerHelper.toDTO(keyword);
    }
}